module.exports = __webpack_public_path__ + "img/soccer_ball.271affeb.gif";